export const REQUEST_DASHBOARD = 'zola/dashboard/REQUEST_DASHBOARD';
export const RECEIVE_DASHBOARD = 'zola/dashboard/RECEIVE_DASHBOARD';



/** WEBPACK FOOTER **
 ** ./src/actions/types/DashboardActionTypes.js
 **/